import React from 'react';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Default, Sale, LastSaleDay, Credit, ChangePlan } from '.';
import { RootStore } from 'providers';
import { Experiments, PurchaseMode } from 'enums';

export const useHeaderContent = (rootStore: RootStore) => {
  const { purchaseMode, isChangePlan: isChangePlanFromPageModeContext } =
    usePageModeContext();
  const {
    isSecondUpgrade,
    isChangePlan: isChangePlanFromAppStore,
    isInSale,
    experiments,
  } = rootStore.appStore;
  const saleBubbleEnabled =
    experiments[Experiments.SunriseV2_EnableSaleBubble] === 'true';
  const unifiedChangePlanPhase1Enabled =
    experiments[Experiments.UnifiedChangePlanPhase1] === 'true';
  const isReplaceChangePlanPurchaseModeEnabled =
    experiments[Experiments.ReplaceChangePlanPurchaseMode] === 'true';
  const changePlan =
    isChangePlanFromAppStore ||
    (isReplaceChangePlanPurchaseModeEnabled
      ? isChangePlanFromPageModeContext
      : purchaseMode === PurchaseMode.CHANGE_PLAN);
  const isUnifiedChangePlan = unifiedChangePlanPhase1Enabled && changePlan;
  const isEligibleForSale = unifiedChangePlanPhase1Enabled || !changePlan;

  if (
    !saleBubbleEnabled &&
    purchaseMode === PurchaseMode.LAST_DAY_SALE &&
    isEligibleForSale
  ) {
    return <LastSaleDay />;
  } else if (!saleBubbleEnabled && isInSale && isEligibleForSale) {
    return <Sale />;
  } else if (isSecondUpgrade || isUnifiedChangePlan) {
    return <Credit />;
  } else if (changePlan) {
    return <ChangePlan />;
  } else {
    return <Default />;
  }
};
